// extracted by mini-css-extract-plugin
export default {"searchform":"doctorsSearchBox_searchform__UyrUv","searchbox":"doctorsSearchBox_searchbox__lsPQj","searchBtn":"doctorsSearchBox_searchBtn__xagMj"};